import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileSparkle"><Path d="M4.5 11.5V2.5H13L19.5 9V21.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 2.5V9H19.5" stroke="currentColor" strokeLinecap="round"/><Path d="M6.4 14H5.6L4.6 16.6L2 17.6V18.4L4.6 19.4L5.6 22H6.4L7.4 19.4L10 18.4V17.6L7.4 16.6L6.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileSparkle;
